// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from '@/store'
import '@/base'
import Modules from './modules'
import App from './App'
import { addScript } from '@/commons/utils'
import VueLazyload from 'vue-lazyload'

let vm = null

const init = () => {
  Vue.config.productionTip = false
  Vue.use(VueLazyload)
  Vue.use(Modules)
  window.JIN10_APP.VueComponents(Vue)
  vm = new Vue({
    components: { App },
    template: '<App/>',
    store,
    el: '#J_ushk'
  })
}

if (process.env.NODE_ENV === 'development') {
  window.Vue = Vue
  addScript('//cdn.jin10.com/assets/js/vue-components/js/index.js', () => {
    init()
  })
} else {
  init()
}



// WEBPACK FOOTER //
// ./src/views/index/main.js